import DashboardLayout from '../layouts/DashboardLayout'
// import CustomerSupport from '../pages/support/CustomerSupport'

export const bituChat = {
    path: '/bitu-chat',
    component: DashboardLayout,
    name: 'BituChat',
    children: [
        {
            path: '/bitu-chat',
            component: () => import (/* webpackChunkName: "about" */'../pages/bituchat/CustomerSupport.vue'),
            meta: {
                roles: ['performancep-mkt-detail_read'],
                requiresAuth: true,
                breadcrumb: [{
                    title: 'Data BC messenger'
                }]
            },
        },
    ],
}